import React from 'react';
import PropTypes from 'prop-types';

import DateWithHover from 'components/timestamps/date_with_hover';

export default function VaultActivityTable({ activities }) {
  if (!activities || activities.length === 0) return null;

  return (
    <table className="table table-condensed">
      <thead>
        <tr>
          <th>Document</th>
          <th>Views</th>
          <th>Last View</th>
        </tr>
      </thead>
      <tbody>
        {activities.map((activityItem, i) => <tr key={i}>
          <td>{activityItem.name}</td>
          <td className={'one-line'}>{activityItem.totalViews}</td>
          <td className={'one-line'}>
            {activityItem.lastAccess && <DateWithHover timestamp={activityItem.lastAccess} />}
          </td>
        </tr>)}
      </tbody>
    </table>
  );
}

VaultActivityTable.defaultProps = {
  activities: []
};

VaultActivityTable.propTypes = {
  activities: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      totalViews: PropTypes.number,
      lastAccess: PropTypes.string
    })
  ).isRequired
};
